// ============================================================================
// LIT-CASE-PAGE — Litigation Cases (Master List)
// ============================================================================
// Court matters — arbitration, NI-Act §138, civil suit, EP.
// Thin wrapper around <LitigationCasesScreen /> that pins category=LITIGATION.

import React from 'react';
import LitigationCasesScreen from 'components/modules/litigation-module/LitigationCasesScreen';

interface Props {
  tabId?: string;
  moduleName?: string;
}

const LitigationCasesPageScreen: React.FC<Props> = ({ tabId, moduleName }) => (
  <LitigationCasesScreen
    tabId={tabId}
    moduleName={moduleName}
    category="LITIGATION"
  />
);

export default LitigationCasesPageScreen;
